import ClientModule from "@gqlapp/module-client-react";
import Route from "@lib/Route";
import View from "@modules/photo/components/view";
import {defaultRoute, getProps} from "@modules/photo/helpers/config";

export default new ClientModule({
	route:{ Photo: <Route {...getProps(defaultRoute, View, { classNameOnPage: 'photo' })} /> }
});
